module.exports = __webpack_public_path__ + "img/logo_header.5db4c386.svg";